import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as colors from '../../../../common/colorConstants';
import { selectLoading } from '../../../../../selectors/partialRefund';
import { processPartialRefund } from '../../../../../actions/tools/PartialRefundActions';
import { selectRefundAmount } from '../../../../../selectors/partialRefund';
import { Spinner, SpinnerWrapper } from '../../../DecisionTree.styles';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { getPresentmentCurrencyCode } from '../../../../../selectors/tools';
import { priceFormat } from '../../../../../util';

const DTPartiallyRefundItemsThenSendMacroNode = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector(selectLoading);
  const refundAmount = useSelector(selectRefundAmount);
  const currency = useSelector(getPresentmentCurrencyCode);

  const refundAmountString = priceFormat(refundAmount, currency);

  const handleNextButtonClick = async () => await dispatch(processPartialRefund());

  if (isLoading) {
    return (
      <SpinnerWrapper>
        <Spinner color={colors.purple1} />
      </SpinnerWrapper>
    );
  }

  return (
    <DTCopyTextSendMacroView
      buttonText={'REFUND & COPY'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={false}
      popupConfirmationText={`You are about to process partial  refund of ${refundAmountString} for the items in this order and copy the response to the text box`}
    />
  );
};

export default withConfirmation(DTPartiallyRefundItemsThenSendMacroNode);
